import React, { useState, useEffect } from 'react';
import './rightClick.css'

const DisableRightClick = () => {

    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        const handleRightClick = (event) => {
        event.preventDefault();
        setShowMessage(true);
        setTimeout(() => {
            setShowMessage(false);
        }, 4000);
        };

        document.addEventListener('contextmenu', handleRightClick);

        return () => {
        document.removeEventListener('contextmenu', handleRightClick);
        };
    }, []);


  return (
    <div className={`disable-right-click-message ${showMessage ? 'show' : ''}`}>
      <div className="message-content">
        <p>Content is protected.  Right-click function is disabled.</p>
      </div>
    </div>
  )
}

export default DisableRightClick